export const STORAGE_KEYS = {
  accessToken: 'accounting-access-token',
  userInfo: 'accounting-user-info',
  activeOrderId: 'activeOrderId',
  loginFromCRM: 'login-from-crm',
};
